import queryString from 'query-string';
import moment from 'moment';


const pikaday = require('pikaday');

require('pikaday/css/pikaday.css');

export function initHelpers() {
    const elements = document.querySelectorAll('[data-module]');

    elements.forEach(element => {
        let module = element.getAttribute('data-module');

        switch(module) {
            case 'navigation-toggle':
                initNavToggle(element)
                break;
            case 'file-input':
                initFileInput(element)
                break;
            case 'tabNavControl':
                initTabControl(element)
                break;
            case 'toggle':
                initToggle(element)
                break;
            case 'datefield':
                initPikaday(element)
                break;
            case 'hover-title':
                initHoverTitle(element)
                break;
            case 'sorttable':
                initSortTable(element)
                break;
            default:
                console.log(`Don't know what to do with this: ${module}`)
                break;
        }
    })
}


export function initSortTable(element) {
    const Tablesort =  import(/* webpackChunkName: "tablesort" */ 'tablesort').then(Tablesort => {
        // var p2 = import (/* webpackChunkName: "tablesort-date" */'./sorts/tablesort.date.min.js')
        // var p3 = import (/* webpackChunkName: "tablesort-dotsep" */'./sorts/tablesort.dotsep.min.js')

        // Promise.all([p2, p3]).then(
        //     values => {
        new Tablesort(element);
        //     }
        // );
    });

}

export function initHoverTitle(el) {
    el.classList.add('hover-parent')
    let titleTexts = el.dataset.hovertitle.split(',');

    let hovercontainer = document.createElement('div');
    hovercontainer.classList.add('hover-container', 'hidden');
    let _descr = document.createElement('p')
    _descr.innerHTML = 'Freigeschaltene Spieler'
    _descr.classList.add('is-size-7', 'is-uppercase')
    hovercontainer.appendChild(_descr)

    titleTexts.map(text => {
        let _p = document.createElement('p')
        _p.textContent = text

        hovercontainer.appendChild(_p);
    })

    el.appendChild(hovercontainer)

    el.addEventListener('click', (e) => {
        hovercontainer.classList.toggle('hidden');
    })
}

export function initNavToggle(el) {
    var toggled = false;
    var navigation = document.querySelector('.ck-aside_nav')

    el.addEventListener('click', (e) => {
        if (!toggled) {
            toggled = true;
            navigation.classList.add('ck-aside_nav--active')

            return el.classList.add('is-active', 'ck-aside_burger--toggled');
        }
        toggled = false;
        navigation.classList.remove('ck-aside_nav--active')
        return el.classList.remove('is-active', 'ck-aside_burger--toggled')
    })
}

export function initFileInput(el) {

    el.addEventListener('change', function() {
        let _label = el.parentElement.querySelector('.file-label')
        let _parentlabel = el.parentElement.querySelector('.ck-file-inline');

        if (el.files.length > 0) {

            _label.innerText = el.files[0].name;
            _parentlabel.classList.add('ck-file-label--success');
            el.parentElement.querySelector('.file-icon i').classList.remove('fa-upload');
            el.parentElement.querySelector('.file-icon i').classList.add('fa-check');

            return;
        }

        _label.innerText = 'Datei auswählen';
        _parentlabel.remove('ck-file-label--success');
        el.parentElement.querySelector('.file-icon i').classList.add('fa-upload');
        el.parentElement.querySelector('.file-icon i').classList.remove('fa-check');

    })
}

function initPikaday(el) {
    let datePicker = new pikaday({
        field: el,
        position: 'bottom_left',
        format: 'DD.MM.YYYY',
        keyboardInput: true,
        onSelect: function() {
            el.value = this.getMoment().format('DD.MM.YYYY');
        },
        i18n: {
            previousMonth : 'vorheriger Monat',
            nextMonth     : 'Nachster Monat',
            months        : ['Jänner','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
            weekdays      : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
            weekdaysShort : ['So','Mo','Di','Mi','Do','Fr','Sa']
        }
    });
}

function initToggle(el) {
    let toggle = el.querySelector('button.toggle');
    let toggleIcon = toggle.querySelector('i.fa');
    let toggletarget = el.querySelector('[data-toggletarget]');

    toggle.addEventListener('click', function(e) {
        if(toggleIcon.classList.contains ('fa-toggle-off')) {
            toggleIcon.classList.remove('fa-toggle-off')
            toggleIcon.classList.add('fa-toggle-on')
        } else {
            toggleIcon.classList.remove('fa-toggle-on')
            toggleIcon.classList.add('fa-toggle-off')
        }
        toggletarget.classList.toggle('is-hidden')
    })
}

function initTabControl(el) {
    let initialQueryString = queryString.parse(location.search);

    const id = el.getAttribute('data-id');
    let toggleSet = false || initialQueryString.tab;

    NodeList.prototype.forEach = Array.prototype.forEach;
    // The Tabcontroller has tabs under his control. When loaded it should hide all except the current active:

    let tabs = document.querySelectorAll('[data-tab]');
    let buttons = document.querySelectorAll('[data-tabcontrol]')

    function toggleTabs(button, target) {
         tabs.forEach(function(tab) {
            if(tab.dataset.tab === target) {
                tab.setAttribute('style', 'display: block;')
                window.history.replaceState(null, null, `?tab=${target}`);
                return;
            }

            tab.setAttribute('style', 'display: none;')
        })

        buttons.forEach(function(_button) {
            if(_button === button) {
                _button.parentElement.classList.add('is-active')
                return;
            }

            _button.parentElement.classList.remove('is-active')

        })
    }

    // if there is no toggle set default to the first toggle:
    if (!toggleSet) {
        toggleSet = buttons[0].dataset.tabtarget
    }

    buttons.forEach(function(button, index) {
        let target = button.dataset.tabtarget;

        button.addEventListener('click', function (event) {
            event.preventDefault();

            toggleTabs(button, target)
        }, false)

        // if (initialQueryString.tab === target) {
        //     toggleSet = true;
        //     return toggleTabs(document.querySelector(`[data-tabtarget="${initialQueryString.tab}"]`), initialQueryString.tab);
        // }
        if(toggleSet && (toggleSet === target)) {
            return toggleTabs(button, target)
        }


    })


}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers.js